// extracted by mini-css-extract-plugin
export default {"root":"_3m9SE","stats":"_2p5Xz","boosted":"_3L0Qe","boosted-text":"_3pejH","boostedText":"_3pejH"};